import { http } from '../utils/axios';
import { getTokenFromLocalStorage } from '../utils/local-storage';
import {
  TDateRange,
  TMomentaryRequest,
  TReportMomentaryResponse,
  TReportTimeframeResponse
} from '../types';

class ReportService {
  private static instance: ReportService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): ReportService {
    if (!ReportService.instance) {
      ReportService.instance = new ReportService();
    }

    return ReportService.instance;
  }

  getReportsByTimeframe = async (payload: TDateRange) => {
    const { data } = await http<TReportTimeframeResponse>({
      url: '/reports/affiliate/dashboard/timeframe',
      method: 'POST',
      data: payload,
      params: {
        access_token: getTokenFromLocalStorage()
      }
    });

    return data;
  };

  getReportsByTimeframeV2 = async (payload: TDateRange) => {
    const { data } = await http<TReportTimeframeResponse>({
      url: '/reports/affiliate/dashboard/timeframe/v2',
      method: 'POST',
      data: payload,
      params: {
        access_token: getTokenFromLocalStorage()
      }
    });

    return data;
  };

  getReportsByMomentary = async (payload: TMomentaryRequest) => {
    const { endDate, startDate, page = 1, limit = 8, status } = payload;
    const { data } = await http<TReportMomentaryResponse>({
      url: '/reports/affiliate/dashboard/momentary',
      method: 'POST',
      data: { endDate, startDate },
      params: { page, limit, status }
    });

    return data;
  };
}

const instance = ReportService.getInstance();

export default instance;
